module.exports = ".dropdown-menu {\n  margin: 0.6rem 1rem 0;\n  border-radius: 0;\n  min-width: 13rem; }\n\n.dropdown-item {\n  padding: 5px 10px;\n  font-size: 12px;\n  font-weight: 400;\n  color: #263238;\n  text-decoration: none;\n  text-transform: uppercase; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/layout/topbar/topbar-menu.component.scss
// module id = ./src/app/shared/components/layout/topbar/topbar-menu.component.scss
// module chunks = main